import {svgIconWrapper} from '../svg-icon-wrapper';

import SquarespaceRegular from './squarespace-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SquarespaceRegular {...props} />;
}

SvgComponent.iconName = 'squarespaceRegular';

export const SquarespaceRegularIcon = svgIconWrapper(SvgComponent);
